import { pianoAnalytics } from 'piano-analytics-js';

export const initAnalytics = () => {
  if (window.VITE_PIANO_ANALYTICS_ENABLE === '1') {
    pianoAnalytics.setConfigurations({
      site: window.VITE_PIANO_ANALYTICS_SITE_ID || '',
      collectDomain: window.VITE_PIANO_ANALYTICS_COLLECT_DOMAIN || '',
    });
  }
};

export const EVENT_NAMES = {
  boutonPourcentageTonnage: 'clic_bouton_pourcentage_tonnage',
} as const;

export const track = (event: string, extra?: Record<string, unknown>) => {
  pianoAnalytics.sendEvent(event, extra);
};
